import React from "react";
import PropTypes from "prop-types";

import APIError from "../APIError";

const DiseaseFundError = ({ title }) => {
  return (
    <div className="Page-banner hasCard">
      <div className="Page-banner-titleContainer">
        <h1 className="Page-banner-pageTitle f-pageTitle-sans u-mb1">
          {title}
        </h1>
      </div>

      <div className="Page-banner-card">
        <div className="Card bg-coral-light-50">
          <div className="Card-inner">
            <div className="Card-inner-content">
              <div className="u-mt5 u-mb5">
                <APIError />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DiseaseFundError.propTypes = {
  title: PropTypes.string.isRequired
};

export default DiseaseFundError;
